const curveSize = 5;
const curveHeight = 4;
const curveSpace = 8;
const webGLTailLayerStyle = {
  brightness: 50,
  contrast: 50,
  gamma: 10,
  saturation: 50,
  exposure: 50,
};

Array.prototype.indexOfObject = function (property, value) {
  for (let i = 0, len = this.length; i < len; i++) {
    if (this[i][property] === value) return i;
  }
  return -1;
};

const slider2layer = (prop, val) => {
  return ["brightness", "contrast", "exposure", "saturation"].includes(prop)
    ? (val - 50) / 50
    : prop == "opacity"
    ? val / 100
    : val / 10;
};

// https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
const stringDivider = (str, width, spaceReplacer) => {
  if (str.length > width) {
    let p = width;
    while (p > 0 && str[p] != " " && str[p] != "-") {
      p--;
    }
    if (p > 0) {
      let left;
      if (str.substring(p, p + 1) == "-") {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      const right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
};

const getGeoTiffPalette = async (url) => {
  // console.log(new Date().toISOString(), "---------- getting image");
  const tiff = await GeoTIFF.fromUrl(url);
  const image = await tiff.getImage();
  const file_dir = image.getFileDirectory();
  let palette = [];
  if (file_dir.ColorMap) {
    const count = Math.pow(2, file_dir.BitsPerSample);
    const greenOffset = file_dir.ColorMap.length / 3;
    const redOffset = greenOffset + file_dir.ColorMap.length / 3;

    for (let i = 0; i < count; i++) {
      const red = Math.floor(file_dir.ColorMap[i] / 256);
      const green = Math.floor(file_dir.ColorMap[greenOffset + i] / 256);
      const blue = Math.floor(file_dir.ColorMap[redOffset + i] / 256);
      const sum = red + green + blue;
      const alpha =
        sum < 5 || sum > 764 || (red == 100 && green == 0 && blue == 0) ? 0 : 1;

      palette.push([red, green, blue, alpha]);
    }
  }
  return palette;
};

const addLayersByProps = (theMap, layers) => {
  // put the bkgnd on first position, the zIndex will be computed according to the order in layers
  const bkgndIndex = layers.indexOfObject("category", "bkgnd");
  if (bkgndIndex > 0) {
    // if there is no bkgnd the result is -1
    const bkgnd = layers[bkgndIndex];
    layers.splice(2, 1);
    layers.unshift(bkgnd);
  }
  // console.log("____________", bkgndIndex, "_____________ read layers from json", layers);

  layers.forEach((l, i) => addLayerByProps(theMap, l, i));
  // console.log(new Date().toISOString(), "Map finaly has", theMap.getLayers().getArray().length, "layer(s)");
};

const addLayerByProps = async (theMap, l, zIndex) => {
  let layer = null;
  let style = {
    variables: {
      brightness:
        l.style && !isNaN(l.style.brightness)
          ? slider2layer("brightness", l.style.brightness)
          : slider2layer("brightness", webGLTailLayerStyle.brightness),
      contrast:
        l.style && !isNaN(l.style.contrast)
          ? slider2layer("contrast", l.style.contrast)
          : slider2layer("contrast", webGLTailLayerStyle.contrast),
      gamma:
        l.style && !isNaN(l.style.gamma)
          ? slider2layer("gamma", l.style.gamma)
          : slider2layer("gamma", webGLTailLayerStyle.gamma),
      saturation:
        l.style && !isNaN(l.style.saturation)
          ? slider2layer("saturation", l.style.saturation)
          : slider2layer("saturation", webGLTailLayerStyle.saturation),
      exposure:
        l.style && !isNaN(l.style.exposure)
          ? slider2layer("exposure", l.style.exposure)
          : slider2layer("exposure", webGLTailLayerStyle.exposure),
    },
    brightness: ["var", "brightness"],
    contrast: ["var", "contrast"],
    gamma: ["var", "gamma"],
    saturation: ["var", "saturation"],
    exposure: ["var", "exposure"],
  };

  let palette = null;
  // console.log("layer", l.name, "l.sourceName", l.sourceName, "style", style);
  switch (l.category) {
    case "bkgnd":
      layer = new ol.layer.Tile({
        preload: Infinity,
        source: new ol.source.XYZ({
          url: l.url,
          maxZoom: l.maxZoom,
        }),
      });
      break;
    case "polar":
      const _palette = await getGeoTiffPalette(l.sources[0].url);
      if (_palette.length) {
        style = { color: ["palette", ["*", 255, ["band", 1]], _palette] };
        palette = _palette;
      }
      layer = new ol.layer.WebGLTile({
        preload: Infinity,
        source: new ol.source.GeoTIFF({
          sources: l.sources,
        }),
        style: style,
      });
      break;
    default:
      console.log("Unknown layer category", l.category);
  }

  // Add layer to map
  if (layer) {
    layer.setZIndex(zIndex);
    let opac = isNaN(l.opacity) ? 1 : slider2layer("opacity", l.opacity);
    if (opac < 0 || opac > 1) opac = 1; // in case there is a value outside of interval [0-100] in the json file
    layer.setOpacity(isNaN(l.opacity) ? 1 : slider2layer("opacity", l.opacity));
    let properties = {
      category: l.category,
      key: l.key,
      name: l.name,
      palette: palette,
    };

    if (l.sourceName) properties.sourceName = l.sourceName;
    if (l.preload) properties.preload = l.preload;
    if (l.url) properties.url = l.url;
    if (l.minZoom) properties.minZoom = l.minZoom;
    if (l.maxZoom) properties.maxZoom = l.maxZoom;
    if (l.sources) properties.sources = l.sources;
    if (!palette) properties.style = style;
    else properties.palette = palette;

    layer.setProperties(properties);
    if (l.category == "bkgnd") {
      theMap.addLayer(layer);
      console.log(
        new Date().toISOString(),
        "Adding layer",
        layer.getProperties().category,
        layer.getProperties().name
      );
      theMap.getView().setMaxZoom(l.maxZoom || 28);
    } else {
      layer.setVisible(false);
      theMap.addLayer(layer);
      console.log(
        new Date().toISOString(),
        "Adding layer",
        layer.getProperties().category,
        layer.getProperties().name
      );
    }
  }
};

const addFeaturesLayer = (theMap, features, featuresMinZoom) => {
  const source = new ol.source.Vector({ features: new ol.Collection() });
  const featureLayer = new ol.layer.Vector({
    type: "vector",
    source: source,
    style: function (feature) {
      return getFeatureStyleFromProps(feature);
    },
  });
  featureLayer.setProperties({ category: "features" });

  if (features.length) {
    features.forEach((f) => {
      const coordinates = f.geometry.coordinates;
      const center = f.geometry.center;
      const radius = f.geometry.radius;
      const geometry =
        f.geometry.type == "Point"
          ? new ol.geom.Point(coordinates.map((c) => ol.proj.fromLonLat(c))[0])
          : f.geometry.type == "Polygon"
          ? new ol.geom.Polygon([coordinates.map((c) => ol.proj.fromLonLat(c))])
          : f.geometry.type == "LineString"
          ? new ol.geom.LineString(
              coordinates.map((c) => ol.proj.fromLonLat(c))
            )
          : f.geometry.type == "Circle"
          ? new ol.geom.Circle(ol.proj.fromLonLat(center), radius)
          : null;

      if (f.geometry.type == "Circle") geometry.setRadius(f.geometry.radius);

      const new_feature = new ol.Feature({
        geometry: geometry,
      });

      new_feature.setProperties(f.geometry.properties);
      new_feature.setId(f.geometry.id);
      source.addFeature(new_feature);
    });
  }
  featureLayer.setVisible(false);
  featureLayer.setZIndex(998);
  if (featuresMinZoom) featureLayer.setMinZoom(featuresMinZoom);
  theMap.addLayer(featureLayer);
};

const changeDataLayersVisibility = (theMap, val, excepted) => {
  const existentLayers = theMap.getLayers().getArray();
  existentLayers.forEach((exl) => {
    const lp = exl.getProperties();
    if (!excepted.includes(exl.getProperties().category)) {
      exl.setVisible(val);
    }
  });
};

const getFeatureStyleFromProps = (feature) => {
  const props = feature.getProperties();
  // console.log("get FeatureStyleFromProps", props);
  if (props.type == "picto" || props.type == "wmo") {
    const style = new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [Math.round(props.size / 2), Math.round(props.size / 2)],
        anchorXUnits: "pixels",
        anchorYUnits: "pixels",
        src: null,
      }),
    });
    return style;
  } else if (props.type == "text") {
    // console.log("get FeatureStyle for", props.type, props);

    return new ol.style.Style({
      text: getStyleText(props),
    });
  } else if (props.type == "text-box") {
    // console.log("get FeatureStyle for", props.type, props);

    return new ol.style.Style({
      text: getStyleText(props),
      stroke: new ol.style.Stroke({
        color: ("#" + props.borderColor).slice(-7),
        width: parseInt(props.borderSize),
      }),
      fill: new ol.style.Fill({
        color: hexToRgbA(("#" + props.bkgndColor).slice(-7), 0.1),
      }),
    });
  } else if (props.drawingTool == "Arrow" || props.drawingTool == "Connector") {
    const [[x, y], [x1, y1]] = props.geometry.getCoordinates();
    const rotation = Math.atan2(y1 - y, x1 - x) - Math.PI / 2;
    const styles = [
      new ol.style.Style({
        stroke: new ol.style.Stroke({
          color: ("#" + props.borderColor).slice(-7),
          width: parseInt(props.borderSize),
        }),
      }),
      new ol.style.Style({
        geometry: new ol.geom.Point([x1, y1]),
        image: new ol.style.RegularShape({
          points: 3,
          radius: parseInt(props.borderSize) * 3,
          fill: new ol.style.Fill({
            color: hexToRgbA(("#" + props.borderColor).slice(-7), 0.8),
          }),
          rotation: -rotation,
          rotateWithView: true,
        }),
      }),
    ];
    return styles;
  } else if (props.drawingTool == "Point") {
    return new ol.style.Style({
      image: new ol.style.Circle({
        stroke: new ol.style.Stroke({
          color: ("#" + props.borderColor).slice(-7),
          width: 2,
        }),
        radius: parseInt(props.borderSize) * 3,
        fill: new ol.style.Fill({ color: ("#" + props.bkgndColor).slice(-7) }),
      }),
    });
  } else if (
    props.meteoCategory == "weather-line" ||
    props.meteoCategory == "weather-zone"
  ) {
    return new ol.style.Style({
      renderer: (coordinates, state) => renderer(props, coordinates, state),
    });
  } else {
    return new ol.style.Style({
      text: getStyleText(props),
      stroke: new ol.style.Stroke({
        color: ("#" + props.borderColor).slice(-7),
        width: parseInt(props.borderSize),
      }),
      fill: new ol.style.Fill({
        color: hexToRgbA(("#" + props.bkgndColor).slice(-7), 0.1),
      }),
    });
  }

  return null;
};

const getStyleText = (props) => {
  if (props.title.length || props.content.length) {
    let titleFormat = props.titleBold
      ? " bold "
      : props.titleItalic
      ? " italic "
      : props.titleUnderline
      ? " underline "
      : " ";
    titleFormat += props.titleSize.code + " " + props.titleFont.code;

    let contentFormat = props.contentBold
      ? " bold "
      : props.contentItalic
      ? " italic "
      : props.contentUnderline
      ? " underline "
      : " ";
    contentFormat += props.contentSize.code + " " + props.contentFont.code;

    return new ol.style.Text({
      text: [
        stringDivider(props.title, 16, "\n"),
        titleFormat,
        "\n",
        "",
        stringDivider(props.content, 16, "\n"),
        contentFormat,
      ],
      fill: new ol.style.Fill({
        color: ("#" + props.titleColor).slice(-7),
      }),
    });
  } else return null;
};

const renderer = (props, coordinates, state) => {
  const ctx = state.context;
  const pts = computePoints(props.meteoCategory, coordinates);

  switch (props.drawingTool) {
    case "ColdFront":
      renderColdFront(props, pts, ctx);
      break;
    case "WarmFront":
      renderWarmFront(props, pts, ctx);
      break;
    case "OccludedFront":
      renderOccludedFront(props, pts, ctx);
      break;
    case "StationaryFront":
      renderStationaryFront(props, pts, ctx);
      break;
    case "DryLine":
      renderDryLine(props, pts, ctx);
      break;
    case "SquallLine":
      renderSquallLine(props, pts, ctx);
      break;
    case "SurfaceTrough":
      renderSurfaceTrough(props, pts, ctx);
      break;
    case "TropicalWave":
      renderTropicalWave(props, pts, ctx);
      break;
    case "ConvergenceLine":
      renderConvergenceLine(props, pts, ctx);
      break;
    case "CATLine":
      renderCATLine(props, pts, ctx);
      break;
    case "Isoline":
      renderIsoline(props, pts, ctx);
      break;
    case "GradientCircle":
      renderGradientCircle(props, coordinates, ctx);
      break;
  }
};

const hexToRgbA = (hex, a) => {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      a +
      ")"
    );
  }
  throw new Error("Bad Hex");
};

const renderColdFront = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();
  if (pts.length > 1) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let the_first = 0;

    for (let i = 1; i < pts.length - 1; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSize * props.borderSize) continue;

      let the_mid = Math.round(the_first + (i - the_first) / 2);
      let dx, dy, dtx, dty, tg;

      tg = Math.atan2(
        pts[the_mid - 1][1] - pts[the_mid + 1][1],
        pts[the_mid + 1][0] - pts[the_mid - 1][0]
      );

      dx = ((curveSize * props.borderSize) / 2) * Math.cos(tg);
      dy = ((curveSize * props.borderSize) / 2) * Math.sin(tg);

      dtx = curveHeight * props.borderSize * Math.cos(tg + Math.PI / 2);
      dty = curveHeight * props.borderSize * Math.sin(tg + Math.PI / 2);

      ctx.beginPath();
      ctx.fillStyle = ("#" + props.borderColor).slice(-7);
      ctx.moveTo(pts[the_mid][0] - dx, pts[the_mid][1] + dy);
      ctx.lineTo(pts[the_mid][0] + dtx, pts[the_mid][1] - dty);
      ctx.lineTo(pts[the_mid][0] + dx, pts[the_mid][1] - dy);
      ctx.fill();

      let j;
      for (j = i; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[j][1])
        );

        if (distance < curveSpace * props.borderSize) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        the_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }
  ctx.restore();
};

const renderWarmFront = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();

  if (pts.length > 1) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let rang_first = 0;

    for (let i = 1; i < pts.length; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSize * props.borderSize) continue;

      let rayon = distance / 2;

      let angle_segment =
        Math.atan2(y_last - pts[i][1], pts[i][0] - x_last) - Math.PI / 2;

      let dx = rayon * Math.sin(angle_segment);
      let dy = rayon * Math.cos(angle_segment);

      let x_c = pts[i][0] + dx;
      let y_c = pts[i][1] + dy;

      let startAngle = -angle_segment + Math.PI / 2;
      let endAngle = -angle_segment + (Math.PI * 3) / 2;

      ctx.beginPath();
      ctx.fillStyle = ("#" + props.borderColor).slice(-7);
      ctx.arc(x_c, y_c, rayon, startAngle, endAngle, props.borderinverted);
      ctx.fill();

      // Go to the next triangle first point (respect the correct space between symbols)

      let j;
      for (j = i; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[j][1])
        );

        if (distance < curveSpace * props.borderSize) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        rang_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }
  ctx.restore();
};

const renderOccludedFront = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();

  if (pts.length > 2) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let rang_first = 0;

    for (let i = 1; i < pts.length - 1; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSize * props.borderSize) continue;

      // Last point of triangle found ==> find the medium point
      let rang_mid = Math.round(rang_first + (i - rang_first) / 2);
      // Calcul de la tangente en ce point
      let dx, dy, dx_top, dy_top, angle_tangente;

      angle_tangente = Math.atan2(
        pts[rang_mid - 1][1] - pts[rang_mid + 1][1],
        pts[rang_mid + 1][0] - pts[rang_mid - 1][0]
      );

      dx = ((curveSize * props.borderSize) / 2) * Math.cos(angle_tangente);
      dy = ((curveSize * props.borderSize) / 2) * Math.sin(angle_tangente);

      dx_top =
        curveHeight * props.borderSize * Math.cos(angle_tangente + Math.PI / 2);
      dy_top =
        curveHeight * props.borderSize * Math.sin(angle_tangente + Math.PI / 2);

      ctx.beginPath();
      ctx.fillStyle = ("#" + props.borderColor).slice(-7);
      ctx.moveTo(pts[rang_mid][0] - dx, pts[rang_mid][1] + dy);
      ctx.lineTo(pts[rang_mid][0] + dx_top, pts[rang_mid][1] - dy_top);
      ctx.lineTo(pts[rang_mid][0] + dx, pts[rang_mid][1] - dy);
      ctx.fill();

      // oclusion arc drawing
      let g;
      for (g = i; g < pts.length; g++) {
        distance = Math.hypot(
          Math.abs(pts[g][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[g][1])
        );

        if (distance < curveSize * props.borderSize) continue;

        let rayon = (distance / 2) * 0.8;

        let angle_segment =
          Math.atan2(pts[i][1] - pts[g][1], pts[g][0] - pts[i][0]) -
          Math.PI / 2;

        let dx = rayon * Math.sin(angle_segment);
        let dy = rayon * Math.cos(angle_segment);

        let x_c = pts[g][0] + dx;
        let y_c = pts[g][1] + dy;

        let startAngle = -angle_segment + Math.PI / 2;
        let endAngle = -angle_segment + (Math.PI * 3) / 2;

        ctx.beginPath();
        ctx.fillStyle = ("#" + props.borderColor).slice(-7);
        ctx.arc(x_c, y_c, rayon, startAngle, endAngle, props.borderinverted);
        ctx.fill();
        break;
      }
      if (g >= pts.length) break;

      // Go to the next triangle first point (respect the correct space between symbols)

      let j;
      for (j = g; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[g][0]),
          Math.abs(pts[g][1] - pts[j][1])
        );

        if (distance < curveSpace * props.borderSize) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        rang_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }
  ctx.restore();
};

const renderStationaryFront = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();

  if (pts.length > 2) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let rang_first = 0;

    for (let i = 1; i < pts.length - 1; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSize * props.borderSize) continue;

      // Last point of triangle found ==> find the medium point
      let rang_mid = Math.round(rang_first + (i - rang_first) / 2);
      // Calcul de la tangente en ce point
      let dx, dy, dx_top, dy_top, angle_tangente;

      angle_tangente = Math.atan2(
        pts[rang_mid - 1][1] - pts[rang_mid + 1][1],
        pts[rang_mid + 1][0] - pts[rang_mid - 1][0]
      );

      dx = ((curveSize * props.borderSize) / 2) * Math.cos(angle_tangente);
      dy = ((curveSize * props.borderSize) / 2) * Math.sin(angle_tangente);

      dx_top =
        curveHeight * props.borderSize * Math.cos(angle_tangente + Math.PI / 2);
      dy_top =
        curveHeight * props.borderSize * Math.sin(angle_tangente + Math.PI / 2);

      ctx.beginPath();
      ctx.fillStyle = ("#" + props.borderColor).slice(-7); //Cld pula: here it is color stationary front
      ctx.moveTo(pts[rang_mid][0] - dx, pts[rang_mid][1] + dy);
      ctx.lineTo(pts[rang_mid][0] + dx_top, pts[rang_mid][1] - dy_top);
      ctx.lineTo(pts[rang_mid][0] + dx, pts[rang_mid][1] - dy);
      ctx.fill();

      // oclusion arc drawing
      let g;
      for (g = i; g < pts.length; g++) {
        distance = Math.hypot(
          Math.abs(pts[g][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[g][1])
        );

        if (distance < curveSize * props.borderSize) continue;

        let rayon = (distance / 2) * 0.8;

        let angle_segment =
          Math.atan2(pts[i][1] - pts[g][1], pts[g][0] - pts[i][0]) -
          Math.PI / 2;

        let dx = rayon * Math.sin(angle_segment);
        let dy = rayon * Math.cos(angle_segment);

        let x_c = pts[g][0] + dx;
        let y_c = pts[g][1] + dy;

        let startAngle = -angle_segment + Math.PI / 2;
        let endAngle = -angle_segment + (Math.PI * 3) / 2;

        ctx.beginPath();
        ctx.fillStyle = ("#" + props.borderColor2).slice(-7);
        ctx.arc(x_c, y_c, rayon, startAngle, endAngle, !props.borderinverted);
        ctx.fill();
        break;
      }
      if (g >= pts.length) break;

      // Go to the next triangle first point (respect the correct space between symbols)

      let j;
      for (j = g; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[g][0]),
          Math.abs(pts[g][1] - pts[j][1])
        );

        if (distance < curveSpace * props.borderSize) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        rang_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }
  ctx.restore();
};

const renderDryLine = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();

  if (pts.length > 2) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let rang_first = 0;

    for (let i = 1; i < pts.length; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSize * props.borderSize) continue;

      let rayon = distance / 2;

      // Last point of triangle found ==> find the medium point
      let rang_mid = Math.round(rang_first + (i - rang_first) / 2);
      // Calcul de la tangente en ce point

      let angle_segment =
        Math.atan2(y_last - pts[i][1], pts[i][0] - x_last) - Math.PI / 2;

      let dx = rayon * Math.sin(angle_segment);
      let dy = rayon * Math.cos(angle_segment);

      let x_c = pts[i][0] + dx;
      let y_c = pts[i][1] + dy;

      let startAngle = -angle_segment + Math.PI / 2;
      let endAngle = -angle_segment + (Math.PI * 3) / 2;

      ctx.beginPath();
      ctx.arc(x_c, y_c, rayon, startAngle, endAngle, props.borderinverted);
      ctx.stroke();

      // Go to the next triangle first point (respect the correct space between symbols)

      let j;
      for (j = i; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[j][1])
        );

        if (distance < 0) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        rang_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }

  ctx.stroke();
  ctx.restore();
};

const renderSquallLine = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.setLineDash([2, 4, 2, 4, 8, 10]);
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);

  ctx.stroke();
  ctx.restore();
};

const renderSurfaceTrough = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);

  ctx.stroke();
  ctx.restore();
};

const renderTropicalWave = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.setLineDash([8, 10]);
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);

  ctx.stroke();
  ctx.restore();
};

const renderConvergenceLine = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.stroke();

  if (pts.length > 2) {
    let x_last = pts[0][0];
    let y_last = pts[0][1];
    let rang_first = 0;
    let other_side = false;
    for (let i = 1; i < pts.length - 1; i++) {
      if (i == 0) continue;

      let distance = Math.hypot(
        Math.abs(pts[i][0] - x_last),
        Math.abs(pts[i][1] - y_last)
      );

      if (distance < curveSpace * props.borderSize) continue;

      let rayon = distance / 2;

      // Last point of triangle found ==> find the medium point
      let rang_mid = Math.round(rang_first + (i - rang_first) / 2);
      // Calcul de la tangente en ce point

      let angle_tangente = Math.atan2(
        pts[i - 1][1] - pts[i + 1][1],
        pts[i + 1][0] - pts[i - 1][0]
      );

      let angle_trace;
      if (other_side) {
        angle_trace = angle_tangente - Math.PI / 6;
        other_side = false;
      } else {
        angle_trace = angle_tangente + Math.PI / 6;
        other_side = true;
      }

      let dx = curveSpace * props.borderSize * Math.cos(angle_trace);
      let dy = curveSpace * props.borderSize * Math.sin(angle_trace);

      ctx.beginPath();
      ctx.moveTo(pts[i][0], pts[i][1]);
      ctx.lineTo(pts[i][0] + dx, pts[i][1] - dy);
      ctx.stroke();

      // Go to the next position first point

      let j;
      for (j = i; j < pts.length; j++) {
        distance = Math.hypot(
          Math.abs(pts[j][0] - pts[i][0]),
          Math.abs(pts[i][1] - pts[j][1])
        );

        if (distance < curveSpace * props.borderSize) continue;

        i = j;
        x_last = pts[i][0];
        y_last = pts[i][1];
        rang_first = i;
        break;
      }

      if (j >= pts.length) break;
    }
  }
  ctx.restore();
};

const renderCATLine = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.setLineDash([8, 10]);
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);

  ctx.stroke();
  ctx.restore();
};

const renderIsoline = (props, pts, ctx) => {
  ctx.save();
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7);
  ctx.globalCompositeOperation = "source-over";

  ctx.arc(pts[0][0], pts[0][1], 0.4, 0, 2 * Math.PI, false);
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);

  ctx.stroke();
  ctx.restore();
};

const renderGradientCircle = (props, coordinates, ctx) => {
  ctx.save();
  const [[x, y], [x1, y1]] = coordinates;
  const dx = x1 - x;
  const dy = y1 - y;
  const radius = Math.sqrt(dx * dx + dy * dy);

  const innerRadius = 0;
  const outerRadius = radius * 1.4;
  const a = hexToRgbA(("#" + props.borderColor2).slice(-7), 0.0);
  const gradient = ctx.createRadialGradient(
    x,
    y,
    innerRadius,
    x,
    y,
    outerRadius
  );
  gradient.addColorStop(
    0,
    hexToRgbA(("#" + props.borderColor2).slice(-7), 0.0)
  );
  gradient.addColorStop(
    0.6,
    hexToRgbA(("#" + props.borderColor2).slice(-7), 0.2)
  );
  gradient.addColorStop(
    1,
    hexToRgbA(("#" + props.borderColor2).slice(-7), 0.8)
  );
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
  ctx.fillStyle = gradient;
  ctx.fill();

  ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
  ctx.lineWidth = props.borderSize;
  ctx.strokeStyle = ("#" + props.borderColor).slice(-7); //"rgba(255,0,0,1)";
  ctx.stroke();
  ctx.restore();
};

const computePoints = (categ, coordinates) => {
  let ptsX = [];
  let ptsY = [];
  let pts = [];

  for (let i = 0; i < coordinates.length; i++) {
    ptsX.push(coordinates[i][0]);
    ptsY.push(coordinates[i][1]);
  }
  if (
    categ == "weather-zone" &&
    ptsX[0] != ptsX[ptsX.length - 1] &&
    ptsY[0] != ptsY[ptsY.length - 1]
  ) {
    ptsX.push(ptsX[0]);
    ptsY.push(ptsY[0]);
  }

  let result = soft_curve(ptsX, ptsY, 45, 1);

  if (result && result.x.length) {
    for (let i = 0; i < result.n; i++) {
      pts.push([result.x[i], result.y[i]]);
    }
  }

  return pts;
};

const soft_curve = (pts_x, pts_y, fct, type) => {
  if (fct == 0 || pts_x.length < 3)
    // the_aki_ma needs 4 point
    return { n: pts_x.length, x: pts_x, y: pts_y, ok: false };

  let n2 = fct * pts_x.length - 1; // create new points && dummy distances

  let input = [0.0],
    output = [],
    i,
    j;

  for (i = 1; i < pts_x.length; i++)
    input[i] =
      input[i - 1] +
      Math.hypot(pts_x[i] - pts_x[i - 1], pts_y[i] - pts_y[i - 1]);

  // new equal distanced points

  let delta = input[pts_x.length - 1] / (n2 - 1);
  let next = delta;
  output[0] = 0.0;
  for (i = j = 1; i < n2; i++) {
    if (j < pts_x.length && input[j] < next) {
      output[i] = input[j++];
      n2++;
    } else {
      output[i] = next;
      next += delta;
    }
  }
  output[n2 - 1] = input[pts_x.length - 1];
  if (output[n2 - 1] == output[n2 - 2]) n2--;

  return {
    n: n2,
    x: interpolation(input, pts_x, pts_x.length, n2, output, type),
    y: interpolation(input, pts_y, pts_x.length, n2, output, type),
    ok: true,
  };
};

const interpolation = (x1, y1, n1, m1, u1, mod) => {
  let vectoru = [],
    _mode = n1 < 3 ? 0 : mod;

  if (_mode == 0) {
    // linear
    for (let i = 1; i < n1; i++) if (x1[i] <= x1[i - 1]) return null;
  }
  let c = _mode == 1 ? the_aki_ma(x1, y1, n1) : the_spl_ine(x1, y1, n1);

  if (c) {
    let j = 0,
      delta = 0;
    for (let i = 0; i < m1; i++) {
      if (u1[i] < x1[0] || u1[i] > x1[n1 - 1]) {
        // out of range
        vectoru[i] = 0;
        continue;
      }
      while (x1[j] > u1[i] && j > 0) j--; // not sorted u1
      while (j < n1 && x1[j] <= u1[i]) j++;
      if (j == n1) j--;
      if (j > 0) j--;
      if (_mode == 0) {
        delta = u1[i] - x1[j];
        vectoru[i] =
          ((y1[j + 1] - y1[j]) * delta) / (x1[j + 1] - x1[j]) + y1[j];
      } else if (_mode == 1) {
        delta = u1[i] - x1[j];
        vectoru[i] =
          ((c[3 * j + 2] * delta + c[3 * j + 1]) * delta + c[3 * j]) * delta +
          y1[j];
      }
    }
    return vectoru;
  }
  return null;
};

const the_aki_ma = (x1, y1, n1) => {
  if (n1 < 3) return null;

  let vectoru = [];
  let t2, b, rm4;

  for (let i = 1; i < n1; i++) {
    if (x1[i] <= x1[i - 1]) return null;
  }

  let res3 = (y1[1] - y1[0]) / (x1[1] - x1[0]);
  let term = res3 - (y1[1] - y1[2]) / (x1[1] - x1[2]);
  let res2 = res3 + term;
  let res1 = res2 + term;

  let nb = n1 - 2;
  for (let i = 0; i < n1; i++) {
    let rm4 =
      i >= nb
        ? res3 - res2 + res3
        : (y1[i + 2] - y1[i + 1]) / (x1[i + 2] - x1[i + 1]);

    let first_term = Math.abs(rm4 - res3);
    let second_term = Math.abs(res2 - res1);
    b = first_term + second_term;
    vectoru[i * 3] =
      b != 0.0
        ? (first_term * res2 + second_term * res3) / b
        : 0.5 * (res2 + res3);
    res1 = res2;
    res2 = res3;
    res3 = rm4;
  }
  nb = n1 - 1;

  for (let i = 0; i < nb; i++) {
    //  the interval n1-1
    let first_term = 1.0 / (x1[i + 1] - x1[i]);
    let second_term = (y1[i + 1] - y1[i]) * first_term;
    b =
      (vectoru[3 * i] + vectoru[3 * i + 3] - second_term - second_term) *
      first_term;
    vectoru[3 * i + 2] = b * first_term;
    vectoru[3 * i + 1] = -b + (second_term - vectoru[3 * i]) * first_term;
  }
  return vectoru;
};

const the_spl_ine = (x1, y1, n1) => {
  let vectorc = [],
    vectoru = [],
    pre,
    sur;

  vectorc[1] = vectorc[n1] = vectoru[1] = 0.0;
  for (let i = 1; i < n1 - 1; i++) {
    sur = (x1[i] - x1[i - 1]) / (x1[i + 1] - x1[i - 1]);
    pre = sur * vectorc[i - 1] + 2.0;
    vectorc[i] = (sur - 1.0) / pre;
    vectoru[i] =
      (y1[i + 1] - y1[i]) / (x1[i + 1] - x1[i]) -
      (y1[i] - y1[i - 1]) / (x1[i] - x1[i - 1]);
    vectoru[i] =
      ((6.0 * vectoru[i]) / (x1[i + 1] - x1[i - 1]) - sur * vectoru[i - 1]) /
      pre;
  }
  for (let k = n1 - 2; k >= 0; k--)
    vectorc[k] = vectorc[k] * vectorc[k + 1] + vectoru[k];

  return vectorc;
};
